import type { CursorPosition } from '../../types';

/**
 * ### getCursorPosition
 *
 * @description
 * Gets the cursor position in a contentEditable element
 *
 * @returns Cursor position or null if no selection
 */
const getCursorPosition = (): CursorPosition | null => {
  const selection = window.getSelection();
  if (!selection || selection.rangeCount === 0) return null;

  const range = selection.getRangeAt(0);
  const rect = range.getBoundingClientRect();

  return {
    x: rect.left,
    y: rect.bottom,
  };
};

export default getCursorPosition;
